import FileUpload from '.';

/** @type {UICore.ComponentMeta} */
const FileUploaderComponentMeta = {
  id: 'fileUploader',
  name: '文件上传',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-uploadfile_1636365775634.png',
  category: '编辑框',
  component: FileUpload,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true,
    checkData: s => s.type === 'string'
  }],
  isFormEditor: true,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string',
      description: 'value 存储的是一个 URL 字符串。\n\n具体上传方式请参考 UICore 文档，或咨询平台开发人员。',
      default: ''
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填'
    }, {
      id: 'placeholder',
      type: 'string',
      default: '输入URL，或点击右侧按钮上传'
    }, {
      id: 'allowInput',
      type: 'boolean',
      title: '允许直接输入URL',
      default: true,
      description: '如果不允许，则只能通过【上传】按钮操作'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '输入框内容发生变化（通常是上传完成后）时触发',
    arguments: [{
      type: 'string',
      description: '修改后的值'
    }]
  }]
};
export default FileUploaderComponentMeta;